import { css } from 'styled-components';

export const DisabledStyles = css`
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
`;
